// extracted by mini-css-extract-plugin
export default {"fullscreen":"VxeHX_TupfViMXbnvudT","icon":"PD_O4rSwgYqXAukJelH_","placeHolderShimmer":"drPmJUNwIJq1QS5dTStv"};